import { render, staticRenderFns } from "./OutlinedNumberIcon.vue?vue&type=template&id=94155cd2&scoped=true&"
import script from "./OutlinedNumberIcon.vue?vue&type=script&lang=js&"
export * from "./OutlinedNumberIcon.vue?vue&type=script&lang=js&"
import style0 from "./OutlinedNumberIcon.vue?vue&type=style&index=0&id=94155cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94155cd2",
  null
  
)

export default component.exports